import OrganizationPathwaySummaryContainer from './organization_pathway_summary_container';

const OrganizationPathwaySummary = OrganizationPathwaySummaryContainer;
export default OrganizationPathwaySummary;
